export function formatDateWithSuffix(date: Date): string {
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "long" });
  const year = date.getFullYear();

  const getOrdinalSuffix = (n: number): string => {
    if (n > 3 && n < 21) return "th";
    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  return `${day}${getOrdinalSuffix(day)} ${month}, ${year}`;
}

export function parsePaymentDate(dateString: string): Date {
  const [day, month, year] = dateString.split("/").map(Number);
  return new Date(year, month - 1, day);
}

export function formatAmountWithComma(amount: number | string): string {
  const num = typeof amount === "string" ? parseFloat(amount) : amount;
  if (isNaN(num)) return "0";
  return num.toLocaleString("en-IN");
}

export function flattenArrayToObject(
  arr: any[],
  keyField: string,
  valueField: string,
  defaults = {}
) {
  return (
    arr &&
    arr.reduce(
      (acc, item) => {
        acc[item[keyField]] = item[valueField];
        return acc;
      },
      { ...defaults }
    )
  );
}
